<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <a class="navbar-brand" routerLink="/admin/trades">Job Titles</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false"
          aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <span class="mr-auto">
      <button
        mat-raised-button
        color="primary"
        class="m-1 mr-2"
        (click)="onAdd()" id="add">
        <mat-icon>add</mat-icon>
        Add Job Title
      </button>

      <mat-menu #appMenu="matMenu">
        <button mat-menu-item (click)="dataSource.selectAllToggle()">
          <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
          {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
        </button>
        <button mat-menu-item (click)="onRemoveSelected()" [disabled]="!dataSource.selection.hasValue()">
          <mat-icon>delete</mat-icon> Delete Selected
        </button>
      </mat-menu>

      <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect job titles." style="min-width: 120px">
        <mat-icon>more_vert</mat-icon>
        List Menu
      </button>
    </span>

    <form tourAnchor="tour.search" class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
      <input
        class="form-control ml-0 mr-2 my-1"
        type="search"
        [(ngModel)]="dataSource.search"
        name="search"
        placeholder="Search"
        matTooltip="Search for Tasks"
        aria-label="Search" />

      <button
        mat-raised-button
        color="secondary"
        type="submit"
        class="mx-0 my-1"
        matTooltip="Run the current search">
        <mat-icon>search</mat-icon> Search
      </button>
    </form>
  </div>
</nav>

<div class="mat-elevation-z8 scroll-box">
  <table mat-table [dataSource]="dataSource" style="width: 100%" matSort matSortActive="name" matSortDisableClear>
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
        <mat-checkbox
          (change)="$event ? dataSource.selectAllToggle() : null"
          [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
          [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? dataSource.selection.toggle(row.id) : null"
          [checked]="dataSource.selection.isSelected(row.id)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        #
      </th>
      <td mat-cell *matCellDef="let trade" class="no-padding text-wrap">
        {{ trade.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Job Title
      </th>
      <td mat-cell *matCellDef="let trade" class="no-padding text-wrap">
        {{ trade.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="creator">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        Created By
      </th>
      <td mat-cell *matCellDef="let trade" class="no-padding">
        <span *ngIf="trade?.created_by_user else showSystemCreator">
          <a (click)="onUserPublicView(trade.created_by_user.hash)"
             matTooltip="View User Public Profile">
            {{ trade.created_by_user.contact_person }}
          </a>
        </span>
        <ng-template #showSystemCreator>System</ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Created At
      </th>
      <td mat-cell *matCellDef="let trade" class="no-padding">
        {{ (trade.date_created * 1000) | timezoneConvertMedium }}
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created_UTC">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Created At (UTC)
      </th>
      <td mat-cell *matCellDef="let trade" class="no-padding">
        {{ (trade.date_created * 1000) | timezoneConvertUTCMedium }}
      </td>
    </ng-container>

    <ng-container matColumnDef="buttons">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="240"></th>

      <td mat-cell *matCellDef="let trade">
        <button type="button" mat-button (click)="onView(trade.id)">
          View
        </button>

        <button type="button" mat-button (click)="onEdit(trade)">
          Edit
        </button>

        <button type="button" mat-button (click)="onRemove(trade)">
          Delete
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator
    [length]="dataSource?.total | async"
    [pageSize]="dataSource.limit"
    [pageSizeOptions]="dataSource.pageSizeOptions"
    showFirstLastButtons>
  </mat-paginator>
</div>
